import React, {FunctionComponent, useState} from 'react';
import {useIntl, FormattedMessage} from 'react-intl';

import {useQuery} from '../../../hooks/useQuery';

import {PRIVACY_LINK} from '../../../constants/links';

import styles from './cookie-banner.module.css';

const COOKIE_NAME = 'cookieConsent';
const COOKIE_REGEX = new RegExp(`^${COOKIE_NAME}=`, 'g');

const CookieBanner: FunctionComponent<Record<string, unknown>> = () => {
  const {formatMessage} = useIntl();
  const cookies = document.cookie.split(';');
  const cookieIsAlreadySet = cookies.some(cookie =>
    cookie.trim().match(COOKIE_REGEX)
  );

  const [showCookieBanner, setShowCookieBanner] = useState<boolean>(
    !cookieIsAlreadySet
  );

  // Do not show cookie banner in exhibition
  const query = useQuery();
  const isExhibition = query.get('exhibition') === 'true';

  if (!showCookieBanner || isExhibition) {
    return null;
  }

  const acceptCookies = () => {
    document.cookie = `${COOKIE_NAME}=true`;
    setShowCookieBanner(false);
  };

  const denyCookies = () => {
    document.cookie = `${COOKIE_NAME}=false`;
    setShowCookieBanner(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <h2>{formatMessage({id: 'cookies.title'})}</h2>
        <FormattedMessage
          id="cookies.description"
          values={{
            h3: (chunks: string) => <h3>{chunks}</h3>,
            p: (chunks: string) => <p>{chunks}</p>,
            privacylink: (chunks: string) => (
              <a href={PRIVACY_LINK} target="_blank" rel="noopener noreferrer">
                {chunks}
              </a>
            ),
            linebreak: <br />
          }}
        />

        <div className={styles.actions}>
          <button className={styles.acceptButton} onClick={acceptCookies}>
            {formatMessage({id: 'cookies.accept'})}
          </button>
          <button className={styles.denyButton} onClick={denyCookies}>
            {formatMessage({id: 'cookies.deny'})}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
